            
/*
    Alternativly we could use swiper js https://swiperjs.com
*/


//import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,

            itemNav : 'basic',
            activateMiddle : false
        };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'slideshow-horizontal-scroll';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
        this.$win           =   $(window);
		
        this.prev = -1;

        this.init( true );
    }

    init( b ){
        this.initSlider( b );
    	this.addEvents( b );
	}

    initSlider(b){
        let options, $frame = this.$el.find( '.frame' ), $li;
        //return;
        if ( b ){


            $frame.find( '.slidee li' ).each( (i,el)=>{
                $li = $(el);
                $li.attr( 'data-index', i );
            });
            this.$slides = $frame.find( '.slidee li' );
            this.max_index = this.$slides.length - 1;


            // Call Sly on frame
            options = {
                horizontal: 1,

                // 'basic', 'centered', 'forceCentered'
                itemNav: this.options.itemNav, //'basic',     
                smart: 1,
                activateMiddle: this.options.activateMiddle,
                mouseDragging: 1,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: 0,
                scrollBar: this.$el.find('.scrollbar'),
                scrollBy: 1,
                speed: 300,
                elasticBounds: 1,
                easing: 'swing', //'easeOutExpo',   
                dragHandle: 1,
                dynamicHandle: 1,
                clickBar: 1,
                //cycleBy:  'items',

                //pagesBar: this.$el.find('.pages'),
                //activatePageOn: 'click',

                // Buttons
                prev:   this.$el.find('.prev'),
                next:   this.$el.find('.next')
            };

            this.sly = new Sly( $frame , options, {

                //load:       (evname) => this.slyEvent(evname),
                //change:     (evname) => this.slyEvent(evname),
                //moveStart:  (evname) => this.slyEvent(evname),
                moveEnd:    (evname) => this.slyEvent(evname)

            }).init();

            this.time = Date.now();

            this.$el.addClass( 'active' );

        }
        else{

            if ( this.sly ){

                this.sly.destroy();
            
            }

            this.$el.removeClass( 'active' );

        }
    }

    addEvents( b ){
        this.debounceResize(b);
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
            this.onResize();
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){
        if ( this.sly ){
            this.sly.reload()
        }
    }


    slyEvent( event ){
        if ( event === 'moveEnd' ){
            //clearTimeout( this.id_trottle );
            //this.id_trottle = setTimeout( ()=>this.onMoveEnd(), 100 );

            if ( this.$win.width() >= 768 ){
                 this.onMoveEnd()
            }
           
        }
     }


    onMoveEnd(){
        let rel, i, time;
        rel = this.sly.rel;
       
        time = Date.now();
        
        if( time - this.time < 500 ){
            return;
        }
        this.time = time;

        if ( this.prev === rel.centerItem ){
            return;
        }
        this.prev = rel.centerItem;


        if ( rel.activeItem !== rel.centerItem ){

            //console.log(  rel.activeItem + ',' + rel.centerItem )

            i = rel.centerItem;

            //this.sly.toStart( i );
            this.sly.activate( i );
        }        

    }


    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        this.init( false );
    }

}